<template>
  <div class="circles">
    <el-tooltip effect="dark" :content="tip" placement="bottom">
      <div class="circle" v-bind:style="'background-color:'+color"></div>
    </el-tooltip>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { isJSON } from '@/utils';

export default {
  computed: {},
  data() {
    return {
      ws: null,
      color: 'gray',
      tip: ''
    };
  },
  created() {
    this.ws = this.websocket;
    // //登录
    // let that = this;

    // this.websocket.ws.onmessage = function(res) {
    //   if (!isJSON(res.data)) {
    //     that.$message.error(
    //       '登录websocket时返回异常数据“' + res.data + '”，请刷新试试'
    //     );
    //     return false;
    //   }
    //   let rtn = JSON.parse(res.data);
    //   if (rtn.retcode < 0) {
    //     that.color = 'red';
    //     that.tip = 'websocket登录错误';
    //   }
    // };

    // this.login();
  },
  methods: {
    // login() {
    //   if (this.websocket.ws && this.websocket.ws.readyState == 1) {
    //     const data = {
    //       messagecode: 1000000,
    //       token: getToken()
    //     };
    //     console.log(['JSON.stringify(data)', JSON.stringify(data)]);
    //     this.websocket.ws.send(JSON.stringify(data));
    //   }else{
    //     setTimeout(() => {
    //       console.log('尝试登陆');
    //       this.login();
    //     }, 5000);
    //   }
    // }
  },
  watch: {
    'ws.color'(n, o) {
      this.color = n;
    },
    'ws.tip'(n, o) {
      this.tip = n;
    }
  }
};
</script> 
<style scoped>
.circles {
  display: inline-flex;
}
.circle {
  width: 20px;
  height: 20px;
  background-color: gray;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Websocket/index.vue